/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrototypeFirmwareDeleteModel
 */
export interface PrototypeFirmwareDeleteModel {
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareDeleteModel
     */
    firmware_id: string;
}

/**
 * Check if a given object implements the PrototypeFirmwareDeleteModel interface.
 */
export function instanceOfPrototypeFirmwareDeleteModel(value: object): value is PrototypeFirmwareDeleteModel {
    if (!('firmware_id' in value) || value['firmware_id'] === undefined) return false;
    return true;
}

export function PrototypeFirmwareDeleteModelFromJSON(json: any): PrototypeFirmwareDeleteModel {
    return PrototypeFirmwareDeleteModelFromJSONTyped(json, false);
}

export function PrototypeFirmwareDeleteModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrototypeFirmwareDeleteModel {
    if (json == null) {
        return json;
    }
    return {
        
        'firmware_id': json['firmware_id'],
    };
}

export function PrototypeFirmwareDeleteModelToJSON(json: any): PrototypeFirmwareDeleteModel {
    return PrototypeFirmwareDeleteModelToJSONTyped(json, false);
}

export function PrototypeFirmwareDeleteModelToJSONTyped(value?: PrototypeFirmwareDeleteModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmware_id': value['firmware_id'],
    };
}

